const { atom } = require('recoil');

const CURRENT_BUSINESS_STORAGE_KEY = 'currentBusinessId';

const getInitialBusinessId = (): string | null => {
  if (typeof window === 'undefined') return null;
  const stored = localStorage.getItem(CURRENT_BUSINESS_STORAGE_KEY);
  return stored || null;
};

export const CurrentBusinessAtom = atom({
  key: 'CurrentBusiness', // unique ID
  default: getInitialBusinessId() as string | null, // default value from localStorage
});

export const syncCurrentBusinessToStorage = (businessId: string | null) => {
  if (typeof window === 'undefined') return;
  if (businessId) {
    localStorage.setItem(CURRENT_BUSINESS_STORAGE_KEY, businessId);
  } else {
    localStorage.removeItem(CURRENT_BUSINESS_STORAGE_KEY);
  }
};
